import { useMemo } from "react";
import Chart from "react-apexcharts";
import { Card, CardContent, Typography, Box, Stack, Divider } from "@mui/material";

const PROCESOS = [
  { key: 'consultas', label: 'Consultas', color: '#1976d2' },
  { key: 'busquedas', label: 'Búsquedas', color: '#ed6c02' },
  { key: 'descargas', label: 'Descargas', color: '#2e7d32' },
];

export const GraficoDistribucion = ({ data }) => {
  const totales = useMemo(() => {
    const t = { consultas: 0, busquedas: 0, descargas: 0 };
    (data || []).forEach((r) => {
      const cant = parseInt(r.cantidad, 10) || 0;
      if (r.proceso === 'consultas') t.consultas += cant;
      else if (r.proceso === 'busquedas') t.busquedas += cant;
      else if (r.proceso === 'descargas') t.descargas += cant;
    });
    return t;
  }, [data]);

  const total = totales.consultas + totales.busquedas + totales.descargas;

  if (!data || data.length === 0 || total === 0) return null;

  const chartOptions = {
    chart: {
      type: 'donut',
      animations: { enabled: true, speed: 600 },
      fontFamily: 'Roboto, sans-serif',
    },
    labels: PROCESOS.map(p => p.label),
    colors: PROCESOS.map(p => p.color),
    legend: { show: false },
    plotOptions: {
      pie: {
        donut: {
          size: '68%',
          labels: {
            show: true,
            name: { show: true, fontSize: '13px', color: '#666', offsetY: -6 },
            value: { show: true, fontSize: '22px', fontWeight: 700, color: '#333', offsetY: 6 },
            total: {
              show: true,
              label: 'Total usos',
              color: '#888',
              fontSize: '12px',
              formatter: () => total.toLocaleString('es-AR'),
            },
          },
        },
      },
    },
    dataLabels: { enabled: false },
    tooltip: { y: { formatter: (v) => `${v.toLocaleString('es-AR')} usos` } },
    stroke: { width: 2, colors: ['#fff'] },
  };

  const series = PROCESOS.map(p => totales[p.key]);

  return (
    <Card elevation={2} sx={{ borderRadius: 3, height: '100%' }}>
      <CardContent>
        <Typography variant="h6" fontWeight={700} mb={0.5}>Distribución por proceso</Typography>
        <Typography variant="body2" color="text.secondary" mb={2}>
          {total.toLocaleString('es-AR')} usos totales en el período
        </Typography>

        <Chart options={chartOptions} series={series} type="donut" height={240} />

        <Divider sx={{ my: 2 }} />

        {/* Leyenda custom debajo */}
        <Stack spacing={1.5}>
          {PROCESOS.map((p) => {
            const valor = totales[p.key];
            const pct = total > 0 ? Math.round((valor / total) * 100) : 0;
            return (
              <Stack key={p.key} direction="row" alignItems="center" spacing={1.5}>
                <Box sx={{ width: 12, height: 12, borderRadius: '50%', bgcolor: p.color, flexShrink: 0 }} />
                <Typography variant="body2" flex={1}>{p.label}</Typography>
                <Typography variant="body2" fontWeight={600} color={p.color}>
                  {valor.toLocaleString('es-AR')}
                </Typography>
                <Typography variant="caption" color="text.secondary" sx={{ minWidth: 36, textAlign: 'right' }}>
                  {pct}%
                </Typography>
              </Stack>
            );
          })}
        </Stack>
      </CardContent>
    </Card>
  );
};
